import { Component, ViewChild } from '@angular/core';
import { LangService } from 'lang/services/lang.services';
import { Router } from '@angular/router';
import { MessageService } from 'shared/services/message/message.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'email-lang',
  templateUrl: './email-lang.component.html',
  styleUrls: ['./email-lang.component.scss']
})
export class EmailLangComponent {
  data: any = {};
  styles = '@import url(https://fonts.googleapis.com/css?family=Nunito+Sans:400,700&display=swap);.body{width:100%!important;height:100%;margin:0;-webkit-text-size-adjust:none}a{color:#3869d4}a img{border:none}td{word-break:break-word}.preheader{display:none!important;visibility:hidden;mso-hide:all;font-size:1px;line-height:1px;max-height:0;max-width:0;opacity:0;overflow:hidden}.body,td,th{font-family:"Nunito Sans",Helvetica,Arial,sans-serif}h1{margin-top:0;color:#0fb9cc;font-size:22px;font-weight:700;text-align:left}h2{margin-top:0;color:#0fb9cc;font-size:16px;font-weight:700;text-align:left}h3{margin-top:0;color:#0fb9cc;font-size:14px;font-weight:700;text-align:left}td,th{font-size:16px}blockquote,ol,p,ul{margin:.4em 0 1.1875em;font-size:16px;line-height:1.625}p.sub{font-size:13px}.align-right{text-align:right}.align-left{text-align:left}.align-center{text-align:center}.button{background-color:#0fb9cc;border-top:10px solid #0fb9cc;border-right:18px solid #0fb9cc;border-bottom:10px solid #0fb9cc;border-left:18px solid #0fb9cc;display:inline-block;color:#fff;text-decoration:none;border-radius:3px;box-shadow:0 2px 3px rgba(0,0,0,.16);-webkit-text-size-adjust:none;box-sizing:border-box}.button--green{background-color:#22bc66;border-top:10px solid #22bc66;border-right:18px solid #22bc66;border-bottom:10px solid #22bc66;border-left:18px solid #22bc66}.button--red{background-color:#ff6136;border-top:10px solid #ff6136;border-right:18px solid #ff6136;border-bottom:10px solid #ff6136;border-left:18px solid #ff6136}@media only screen and (max-width:500px){.button{width:100%!important;text-align:center!important}}.attributes{margin:0 0 21px}.attributes_content{background-color:#0fb9cc;padding:16px}.attributes_item{padding:0}.related{width:100%;margin:0;padding:25px 0 0 0;-premailer-width:100%;-premailer-cellpadding:0;-premailer-cellspacing:0}.related_item{padding:10px 0;color:#cbcccf;font-size:15px;line-height:18px}.related_item-title{display:block;margin:.5em 0 0}.related_item-thumb{display:block;padding-bottom:10px}.related_heading{border-top:1px solid #cbcccf;text-align:center;padding:25px 0 10px}.discount{width:100%;margin:0;padding:24px;-premailer-width:100%;-premailer-cellpadding:0;-premailer-cellspacing:0;background-color:#0fb9cc;border:2px dashed #cbcccf}.discount_heading{text-align:center}.discount_body{text-align:center;font-size:15px}.social{width:auto}.social td{padding:0;width:auto}.social_icon{height:20px;margin:0 8px 10px 8px;padding:0}.purchase{width:100%;margin:0;padding:35px 0;-premailer-width:100%;-premailer-cellpadding:0;-premailer-cellspacing:0}.purchase_content{width:100%;margin:0;padding:25px 0 0 0;-premailer-width:100%;-premailer-cellpadding:0;-premailer-cellspacing:0}.purchase_item{padding:10px 0;color:#51545e;font-size:15px;line-height:18px}.purchase_heading{padding-bottom:8px;border-bottom:1px solid #eaeaec}.purchase_heading p{margin:0;color:#85878e;font-size:12px}.purchase_footer{padding-top:15px;border-top:1px solid #eaeaec}.purchase_total{margin:0;text-align:right;font-weight:700;color:#333}.purchase_total--label{padding:0 15px 0 0}.body{background-color:#0fb9cc;color:#fff}p{color:#51545e}p.sub{color:#6b6e76}.email-wrapper{width:100%;margin:0;padding:0;-premailer-width:100%;-premailer-cellpadding:0;-premailer-cellspacing:0;color:#fff;background-color:#0fb9cc}.email-content{width:100%;margin:0;padding:0;-premailer-width:100%;-premailer-cellpadding:0;-premailer-cellspacing:0}.email-masthead{padding:25px 0;text-align:center}.email-masthead_logo{width:94px}.email-masthead_name{font-size:16px;font-weight:700;color:#a8aaaf;text-decoration:none;text-shadow:0 1px 0 #fff}.email-body{width:100%;margin:0;padding:0;-premailer-width:100%;-premailer-cellpadding:0;-premailer-cellspacing:0;background-color:#fff}.email-body_inner{width:570px;margin:0 auto;padding:0;-premailer-width:570px;-premailer-cellpadding:0;-premailer-cellspacing:0;background-color:#fff}.email-footer{width:570px;margin:0 auto;padding:0;-premailer-width:570px;-premailer-cellpadding:0;-premailer-cellspacing:0;text-align:center}.email-footer p{color:#6b6e76}.body-action{width:100%;margin:30px auto;padding:0;-premailer-width:100%;-premailer-cellpadding:0;-premailer-cellspacing:0;text-align:center}.body-sub{margin-top:25px;padding-top:25px;border-top:1px solid #eaeaec}.content-cell{padding:35px}@media only screen and (max-width:600px){.email-body_inner,.email-footer{width:100%!important}}@media (prefers-color-scheme:dark){.body,.email-body,.email-body_inner,.email-content,.email-footer,.email-masthead,.email-wrapper{background-color:#333!important;color:#fff!important}blockquote,h1,h2,h3,ol,p,ul{color:#fff!important}.attributes_content,.discount{background-color:#222!important}.email-masthead_name{text-shadow:none!important}}';
  lang1 = 'en-us';
  key1 = 'sign_up_confirmation';
  languages1 = [];
  categories1 = [];
  editor: any;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: false,
    toolbarPosition: 'top'
  };
  @ViewChild('editor', { static: false })
  set pane(v: any) {
    setTimeout(() => { this.editor = v; }, 0);
  }

  constructor(private langService: LangService, private router: Router, private messageService: MessageService) {
    this.changeLang1();
  }

  changeLang1() {
    this.langService.getLangByKeyLang(this.lang1, this.key1).subscribe((res: any) => {
      if (res) {
        this.data = res;
      } else {
        this.data = {};
      }
    }, (error) => {
      this.messageService.genericError();
    });
  }
  saveOrUpdate() {
    if(this.data.value && this.data.value.indexOf('div class="body"')<0){
      this.data.value = '<div class="body">'+this.data.value+'</div>';
    }
    if(this.data.value && this.data.value.indexOf('<body>')<0){
      this.data.value = '<body>'+this.data.value+'</body>';
    }
    if(this.data.value && this.data.value.indexOf('<head>')<0){
      this.data.value = '<head><style>'+this.styles+'</style></head>'+this.data.value;
    }
    if(this.data.value && this.data.value.indexOf('<html>')<0){
      this.data.value = '<html>'+this.data.value+'</html>';
    }
    this.langService.saveOrUpdate({ i18n: this.lang1, item: this.data }).subscribe((res: any) => {
      this.messageService.showSuccess('changes saved successfully', this.lang1);
    }, (error) => {
      this.messageService.genericError();
    });
  }
}